import { V2EnergyGetAreaEnergyStatisticsPostResponse } from '@maxtropy/device-customer-apis-v2';
import { EchartsWithTheme, Empty, useTheme } from '@maxtropy/components';
import { getBarChartOption } from './chart';
import { DateType } from '../../utils';
import titleIcon from '../../imgs/icon-title.png';

type BottomChart = V2EnergyGetAreaEnergyStatisticsPostResponse['chartData'];

const BottomChart = ({ data, resolution }: { data: BottomChart; resolution: DateType }) => {
  const theme = useTheme();

  return (
    <div>
      {data?.map((item, index) => (
        <div key={index}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', margin: '16px 0 24px' }}>
            <img src={titleIcon} style={{ width: 16, height: 16, marginRight: 4 }} />
            <div style={{ fontSize: 16, color: 'var(--mx-text-base-color)', fontWeight: 500 }}>{item.mediumName}</div>
          </div>
          <EchartsWithTheme
            option={getBarChartOption(item.detailList, resolution, item.unit)}
            empty={{
              isShowEmpty: item.detailList?.length === 0,
              emptyNode: <Empty style={{ marginTop: 60, minHeight: 300 }} />,
            }}
            theme={theme}
            style={{ height: 300, width: '100%' }}
            params={{
              dataZoomExit: true,
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default BottomChart;
